import * as d3 from 'd3-selection'
import defs from './defs.js'
import triangle from './triangle.js'

export default function (selection, id, dimensions, scaler, validThresholds) {
  selection.each(function (data) {
    var gauge = d3.select(this)
      , thresholds = gauge.selectAll('g.thresholds')
                          .attr('transform', 'translate(' + dimensions.innerPadding + ',' + dimensions.innerPadding + ')')
      , currentLabelWidth = dimensions.gaugeWidth * .3
      , currentLabelMarginRight = currentLabelWidth / 15
      , gaugeBorderWidth = dimensions.gaugeWidth * .4
      , thresholdWidth = dimensions.gaugeWidth - currentLabelWidth - gaugeBorderWidth - dimensions.margin.right
      , thresholdFontSize = (dimensions.gaugeWidth / 40) + 8
      , thresholdsLeftMargin = thresholdFontSize * 0.6 // move the thresholds left/right slightly
      , coloredBarWidth = Math.max(0, gaugeBorderWidth - (dimensions.innerPadding * 2))
      , innerGaugeHeight = Math.max(0, dimensions.gaugeHeight - dimensions.innerPadding * 2) // used for calculating `y` positions
      , triangleSize = Math.min(coloredBarWidth + 3, ((coloredBarWidth / 3.3) + 15))
      , triangleStrokeWidth = triangleSize * 0.08
      , currentTriangleOffset = dimensions.innerPadding - 3
      , currentTrianglePath = triangle(triangleSize)
      , previousTrianglePath = triangle(triangleSize * 0.8) // previous triangle is smaller the the current one
      , minFontSize = 6

    d3.select(this.parentNode)
      .call(defs(id, dimensions.cornerRadius, gaugeBorderWidth, dimensions.gaugeHeight, currentLabelWidth, 0))

     // Draw the threshold colors bars
    thresholds.selectAll('rect')
              .attr('y', function (d) {
                return innerGaugeHeight - d.start - d.length
              })
              .attr('x', currentLabelWidth)
              .attr('width', coloredBarWidth)
              .attr('height', function (d) {
                return d.length
              })
              .style('stroke-width', dimensions.rectStrokeWidth)

    // Position the current triangle
    thresholds.selectAll('path.value-indicator.current')
              .style('stroke-width', triangleStrokeWidth)
              .attr('d', currentTrianglePath)
              .attr('transform', function (d) {
                var rect = this.parentNode.querySelector('rect:first-child').getBBox()
                  , x = rect.x + this.getBBox().height / 2  // right on the outer line
                          - currentTriangleOffset // extend it into the inner padding
                  , y = innerGaugeHeight - (scaler(d.raw) + d.offset)

                return 'translate(' + x + ',' + y + ') rotate(-90)'
              })

    // Previous value triangle
    thresholds.selectAll('path.previous')
              .attr('d', previousTrianglePath)
              .attr('transform', function (d) {
                var rect = this.parentNode.querySelector('rect:first-child').getBBox()
                  , x = rect.x + rect.width - this.getBBox().height / 2 + dimensions.rectStrokeWidth / 2
                  , y = innerGaugeHeight - (scaler(d.value) + d.offset)

                return 'translate(' + x + ',' + y + ') rotate(90)'
              })

    // Adjust threshold label position
    thresholds.selectAll('g.threshold-label')
              .attr('transform', function (d, i, all) {
                return 'translate(' + (currentLabelWidth + gaugeBorderWidth - dimensions.innerPadding + thresholdsLeftMargin) + ',' + ((dimensions.gaugeHeight - dimensions.innerPadding * 2) - d.position) + ')'
              })
              .select('text')
              .attr('font-size', function () {
                return thresholdFontSize
              })
              .select(function () {
                // After the font-size has been set, determine if we need to shrink the labels to fit within the available space
                var fontSize = thresholdWidth * (thresholdFontSize / this.getComputedTextLength())

                d3.select(this)
                  .attr('font-size', function () {
                    var t = Math.min(thresholdFontSize, fontSize)
                    return t > minFontSize ? t : 0
                  })
                return this
              })
              .attr('dy', '.4em')

    // Position the current text labels
    var currentLabelGroup = thresholds.selectAll('g.current-label')
                                      .attr('transform', function (d) {
                                        var y = dimensions.gaugeHeight / 2 // By default, center

                                        if (typeof d.raw !== 'undefined' && validThresholds) {
                                          y = scaler(d.raw) + d.offset + dimensions.innerPadding * 2
                                        }

                                        return 'translate(' + (currentLabelWidth - dimensions.innerPadding - currentLabelMarginRight) + ',' + (dimensions.gaugeHeight - y) +  ')'
                                      })

    currentLabelGroup.selectAll('text')
                     .attr('font-size', function (d, i) {
                       // Set the initial font size with the assumption it can fit
                       return (((currentLabelWidth - currentLabelMarginRight) / 10) + 14) / (i + 1) // units is 50% of value by default
                     })
                     .select(function () {
                       var spaceAvailable = (currentLabelWidth - currentLabelMarginRight)
                         , currentFontSize = parseFloat(d3.select(this).attr('font-size'))
                         , fontSize = spaceAvailable * (currentFontSize / this.getComputedTextLength())

                       d3.select(this)
                         .attr('font-size', function () {
                           var t = Math.min(fontSize, currentFontSize)
                           return t > minFontSize ? t : 0
                         })
                       return this
                     })
                     .attr('dy', '.4em')

    currentLabelGroup.select('g.text-units')
                     .attr('transform', function () {
                       var offset = 3
                         , y = this.previousSibling.getBBox().height / 2 + offset
                       return 'translate(0,' + y + ')'
                     })
  })
}
